import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const  resource = "/supplier";
export default {
  updateStaffPassword(payload){
    return Repository.post(`${resource}/change-password`, payload)
  },
  accountVerify(code) {
    return Repository.get(`${resource}/verify/${code}`)
  },
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/users?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  createSupplierUser(payload) {
    return Repository.post(`${resource}/users`, payload)
  },
  getSupplierUser(id){
    return Repository.get(`${resource}/users/${id}`)
  },
  updateSupplierUser(id, payload){
    return Repository.put(`${resource}/users/${id}`, payload)
  },
  updateSupplierBasicDetails(payload){
    return Repository.put(`${resource}/suppliers`, payload)
  },
  getBasicSupplierDetails() {
    return Repository.get(`${resource}/suppliers/get-details`)
  },
  uploadFile(file) {
    console.log(file)
    return Repository.post(`${resource}/file-upload`, file, {headers: {
        'Content-Type': 'multipart/form-data'
      }})
  },
  getManufactureSiteStatus(id) {
    return Repository.get(`${resource}/saq/manufacture/get-status/${id}`)
  },
  forgotPassword(payload) {
    return Repository.post(`${resource}/forgot-password`, payload)
  },
  getForgotPasswordToken(token){
    return Repository.get(`${resource}/forgot-password/${token}`)
  },
  passwordReset(payload){
    return Repository.post(`${resource}/reset-password`, payload)
  },
  resendUserWelcomeEmail(email){
    return Repository.put(`${resource}/${email}/supplier-user-resend`)
  },
  getSupplierRoles() {
    return Repository.get(`/supplier/roles?paginate=100`)
  }
};
